import React from "react";

import { IconMetrics } from "~/components/icon";
import { RemoteData } from "~/tools/remote-data";

import { DrawerTitle, ExplorationDrawer } from "../react/drawer/ExplorationDrawer";

import { Content } from "./_content";
import { PinComponentButton } from "./_pin-component-button";
import type { MetricsDrawerState } from "./state";

export interface MetricsDrawerProps {
	when: undefined | MetricsDrawerState;
}

export const MetricsDrawer: React.FC<MetricsDrawerProps> = ({ when }) => (
	<ExplorationDrawer
		headerActions={({ timestamp, title, unit, metricQueries, componentIdOrIdentifier }) =>
			componentIdOrIdentifier != null && (
				<PinComponentButton
					componentIdOrIdentifier={componentIdOrIdentifier}
					metricQueries={metricQueries}
					timestamp={timestamp}
					title={title}
					unit={unit}
				/>
			)
		}
		headerTitle={({ title = "" }) => <DrawerTitle icon={<IconMetrics height={20} width={20} />} title={title} />}
		when={when}
	>
		{({ unit, metricQueries, timestamp, timeRange }) => (
			<Content model={RemoteData.success({ unit, metricQueries })} timeRange={timeRange} timestamp={timestamp} />
		)}
	</ExplorationDrawer>
);
